module.exports = __webpack_public_path__ + "media/social/link-youtube-57caca98.png";